import { FullScreenPage, Skeleton, Stack } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export function HireStepLoading() {
  const { t } = useTranslation();

  return (
    <FullScreenPage isCenterVertical={true} title={t("common:loading")}>
      <Stack gap={"md"} className={"text-center"}>
        <Skeleton className={"h-5 w-140"} />
      </Stack>
    </FullScreenPage>
  );
}
